import React from 'react'
import { SubTask } from '../../types'
import useUpdatePoolTaskSubmissions from '../../../../../hooks/useUpdatePoolTaskSubmissions'
import SharedFormTaskCard from '../../../../../shared_components/Missions/Types/Form'

const FormTaskCard = ({
  subtask,
  taskId,
  reward,
  isEthRaise = false,
  maxReward,
}: {
  subtask: SubTask
  taskId: number
  reward: number
  isEthRaise?: boolean
  maxReward?: number
}) => {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  
  return <SharedFormTaskCard
    subtask={subtask}
    taskId={taskId}
    reward={reward}
    updateTaskSubmissions={updateTaskSubmissions}
    isEthRaise={isEthRaise}
    maxReward={maxReward}
  />
}

export default FormTaskCard
